// extracted by mini-css-extract-plugin
export default {"content":"Homepage_content__xb3ql","intro":"Homepage_intro__56hVt"};